import {Alert, Button, message} from "antd";
import {
  StyledAccountDetailsBoxWrapper,
  StyledBankIconAndAccountDetailsWrapper,
  StyledConnectBankAccountBoxContentWrapper,
  StyledConnectBankAccountBoxWrapper,
  StyledPersonalAccountDetailsWrapper,
} from "./styles";
import {usePayoutSettingsContext} from "../tabs/payout-settings-tab/context";
import {AccountDetailsForm} from "../tabs/payout-settings-tab/form";
import {AccountDetailsOTPView} from "../tabs/payout-settings-tab/otp-view";
import {useFetchAccountDetailsContext} from "./context/fetch-account-details.context";
import {PayoutWithdrawalModal} from "../tabs/withdrawal-tab/balance-section/withdrawal-modal";
import {useState} from "react";
import {useWithdrawalDetails} from "../../../../react-query-hooks/payout";
import {CustomModal} from "../../../modal";
import {StyledModalContentWrapper} from "../../../calls/upcoming-calls/call-card/call-card.style";
import {ErrorBoundary} from "react-error-boundary";
import {useDisconnectBankAccount} from "../../../../features/bank-accounts/hooks/useStripeActions";

export function PayoutSettingsFlow() {
  const {state} = usePayoutSettingsContext();
  // console.log({state});

  function handleView() {
    let content;
    switch (state.currentStep.currentView) {
      case "otp":
        content = <AccountDetailsOTPView />;
        break;
      case "form":
        content = <AccountDetailsForm />;
        break;
      default:
      case "initial":
        content = <ConnectBankAccountBox />;
    }
    return content;
  }
  return (
    <StyledConnectBankAccountBoxWrapper>
      {handleView()}
    </StyledConnectBankAccountBoxWrapper>
  );
}
export function ConnectBankAccountBox({
  variant = "settings",
}: {
  variant?: "onboarding" | "settings";
}) {
  const {state} = useFetchAccountDetailsContext();
  const hasAccountDetails = !!state.accountDetails?.bank;
  return (
    <>
      <StyledConnectBankAccountBoxContentWrapper>
        <p className="info-text">
          Set up your payout details to enable you receive your earnings
        </p>
        <AccountDetailsBox
          hasAccountDetails={hasAccountDetails}
          variant={variant}
          isStripeAndInactive={state.isStripeAndInactive}
        />
      </StyledConnectBankAccountBoxContentWrapper>
    </>
  );
}

export function AccountDetailsBox({
  hasAccountDetails,
  variant = "settings",
  isStripeAndInactive = false,
}: {
  hasAccountDetails: boolean;
  variant?: "onboarding" | "settings";
  isStripeAndInactive?: boolean;
}) {
  return (
    <>
      <StyledAccountDetailsBoxWrapper>
        <StyledBankIconAndAccountDetailsWrapper>
          <BankIconBox />
          {hasAccountDetails ? <PersonalAccountDetails /> : <NoPersonalAccountDetails />}
        </StyledBankIconAndAccountDetailsWrapper>
        {hasAccountDetails ? (
          variant === "settings" || isStripeAndInactive ? (
            <UpdateAccountDetailsButton />
          ) : null
        ) : (
          <ConnectAccountButton />
        )}
      </StyledAccountDetailsBoxWrapper>
    </>
  );
}

function BankIconBox() {
  return (
    <div>
      <svg
        width="66"
        height="66"
        viewBox="0 0 66 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="66" height="66" rx="4" fill="#E7EDE1" />
        <path
          d="M44.9379 31.4365C45.9035 31.4365 46.3066 30.1959 45.5222 29.624L33.5879 20.9427C33.4174 20.8179 33.2116 20.7505 33.0004 20.7505C32.7891 20.7505 32.5833 20.8179 32.4129 20.9427L20.4785 29.624C19.6941 30.1927 20.0972 31.4365 21.066 31.4365H23.0004V43.124H20.7504C20.6129 43.124 20.5004 43.2365 20.5004 43.374V44.999C20.5004 45.1365 20.6129 45.249 20.7504 45.249H45.2504C45.3879 45.249 45.5004 45.1365 45.5004 44.999V43.374C45.5004 43.2365 45.3879 43.124 45.2504 43.124H43.0004V31.4365H44.9379ZM33.0004 23.1459L41.4722 29.3084H24.5285L33.0004 23.1459ZM25.2504 31.4365H28.9066V43.124H25.2504V31.4365ZM31.1566 31.4365H34.8129V43.124H31.1566V31.4365ZM40.7504 43.124H37.0629V31.4365H40.7504V43.124Z"
          fill="#32A49E"
        />
      </svg>
    </div>
  );
}

export function NoPersonalAccountDetails() {
  return (
    <StyledPersonalAccountDetailsWrapper>
      <p className="bold-text">Bank account</p>
      <p>Connect bank account</p>
    </StyledPersonalAccountDetailsWrapper>
  );
}
export function PersonalAccountDetails() {
  const {state} = useFetchAccountDetailsContext();
  if (!state.accountDetails) {
    return <NoPersonalAccountDetails />;
  }
  return (
    <StyledPersonalAccountDetailsWrapper>
      <p className="bold-text">{state.accountDetails.bank.account_name}</p>
      <p>
        <span>{state.accountDetails.bank.bank_name}</span> -{" "}
        <span>{state.accountDetails.bank.account_number}</span>
      </p>
      <p>
        Default currency -{" "}
        <span className="bold-text">{state.accountDetails.bank.currency}</span>
      </p>
    </StyledPersonalAccountDetailsWrapper>
  );
}

export function ConnectAccountButton() {
  const {dispatch} = usePayoutSettingsContext();
  function handleConnectAccountClick() {
    dispatch({
      type: "update-payment-settings-flow",
      payload: {
        currentView: "form",
        type: "create",
      },
    });
  }
  return (
    <div>
      <Button onClick={handleConnectAccountClick} size="small" type="primary">
        Connect account
      </Button>
    </div>
  );
}
export function UpdateAccountDetailsButton() {
  const [openWithdrawalModal, setOpenWithdrawalModal] = useState<boolean>(false);
  const [showPendingBalanceModal, setShowPendingBalanceModal] = useState<boolean>(false);
  const [showResetModal, setShowResetModal] = useState<boolean>(false);
  const {state} = useFetchAccountDetailsContext();
  const {dispatch} = usePayoutSettingsContext();
  const disconnectBankAccountMutation = useDisconnectBankAccount();
  const [accountBalance, pendingPayout, connectedBank] = useWithdrawalDetails({
    connectBankUniqueIdentifier: "pending_balance_modal",
  });

  const showWithdrawalModal = () => {
    setOpenWithdrawalModal(true);
    setShowPendingBalanceModal(false);
  };
  const handleModalCancel = () => {
    setOpenWithdrawalModal(false);
  };
  const handleModalOk = () => {
    setOpenWithdrawalModal(false);
  };
  const handlePendingBalanceModalCancel = () => {
    setShowPendingBalanceModal(false);
  };
  const handlePendingBalanceModalOk = () => {
    setShowPendingBalanceModal(false);
    showWithdrawalModal();
  };

  function handleUpdateAccountDetailsClick() {
    if (state.isStripeAndInactive && state.accountDetails?.bank.loginUrl) {
      window.open(state.accountDetails.bank.loginUrl);
      return;
    }
    dispatch({
      type: "update-payment-settings-flow",
      payload: {
        currentView: "form",
        type: "update",
      },
    });
  }

  const handleResetClick = () => setShowResetModal(true);
  const handleResetCancel = () => setShowResetModal(false);
  const handleResetConfirm = () => {
    disconnectBankAccountMutation.mutate(undefined, {
      onSuccess: () => setShowResetModal(false),
    });
  };

  return (
    <div style={{display: "flex", gap: "0.8rem", flexWrap: "wrap"}}>
      <Button onClick={handleUpdateAccountDetailsClick} size="small" type="primary">
        {state.isStripeAndInactive
          ? "Complete Stripe registration"
          : "Update account details"}
      </Button>
      {state.isStripeAndInactive && (
        <Button onClick={handleResetClick} size="small" danger>
          Reset
        </Button>
      )}

      <CustomModal
        centered
        visibleState={showResetModal}
        title="Reset Stripe verification?"
        okFunc={handleResetConfirm}
        cancelFunc={handleResetCancel}
        footerContent={[
          <Button
            size="small"
            key="confirm-reset"
            type="primary"
            danger
            loading={disconnectBankAccountMutation.isLoading}
            onClick={handleResetConfirm}
          >
            Yes, proceed
          </Button>,
          <Button
            size="small"
            key="cancel-reset"
            type="default"
            onClick={handleResetCancel}
            disabled={disconnectBankAccountMutation.isLoading}
          >
            Cancel
          </Button>,
        ]}
      >
        <StyledModalContentWrapper>
          <p>
            Are you sure you want to proceed? This will disconnect your payout account and
            clear any verification progress you have made with Stripe. You&apos;ll need to
            start the verification process again.
          </p>
        </StyledModalContentWrapper>
      </CustomModal>

      <CustomModal
        centered
        visibleState={showPendingBalanceModal}
        title="You have an active balance in your current currency"
        okFunc={handlePendingBalanceModalOk}
        cancelFunc={handlePendingBalanceModalCancel}
        footerContent={[
          <Button size="small" key="save" type="primary" onClick={showWithdrawalModal}>
            Withdraw funds
          </Button>,
          <Button
            size="small"
            key="cancel"
            type="default"
            onClick={handlePendingBalanceModalCancel}
          >
            Cancel
          </Button>,
        ]}
      >
        <StyledModalContentWrapper>
          <ErrorBoundary
            FallbackComponent={({error, resetErrorBoundary}) => (
              <div style={{marginTop: "1.8rem"}}>
                <Alert
                  message="Sorry, something went wrong."
                  showIcon
                  description={error.message}
                  type="error"
                  action={
                    <Button
                      onClick={() => {
                        resetErrorBoundary();
                      }}
                      size="small"
                      danger
                    >
                      Reset
                    </Button>
                  }
                />
              </div>
            )}
          >
            <p>
              To update your bank account, you’ll need to withdraw your remaining balance
              of{" "}
              <b>
                {connectedBank.data?.bank.currency ??
                  state.accountDetails?.bank.currency ??
                  "NGN"}
              </b>{" "}
              <b>{accountBalance.data?.balance.toLocaleString("en-US") ?? "0"}</b> first.
            </p>
          </ErrorBoundary>
        </StyledModalContentWrapper>
      </CustomModal>
      <PayoutWithdrawalModal
        handleModalCancel={handleModalCancel}
        handleModalOk={handleModalOk}
        visibleState={openWithdrawalModal}
        stripeDetails={{
          isStripe: state.isStripe,
          isStripeAndActive: state.isStripeAndActive,
          isStripeAndInactive: state.isStripeAndInactive,
        }}
      />
    </div>
  );
}
